<div class="d-flex flex-column align-items-center">
  <img
    *ngIf="data?.isSuccess === true; else error"
    src="assets/svg/ico_confirm.svg"
    alt="Confirm Icon"
    width="55"
  >
  <ng-template #error>
    <img
      *ngIf="data?.isSuccess === false; else default"
      src="assets/svg/ico_error.svg"
      alt="Error Icon"
      width="55"
    >
  </ng-template>
  <ng-template #default>
    <div width="192px" style="height: 120px ">
      <img src="assets/gif/bounce-ball-small.gif" alt="bouncing_loader" width="110px"/>
    </div>
  </ng-template>
  <span class="loading-message lato bold mt-2">{{ data?.message ? data?.message : 'Loading' }}</span>
  <span
    *ngIf="data?.description"
    class="lato mt-1"
  >{{ data?.description }}</span>
</div>
